/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React, { useEffect, useState } from "react";
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useAccount, useIsAuthenticated } from "@azure/msal-react";

import "../styles/App.css";
import { IPublicClientApplication, EventMessage, EventType, AuthenticationResult, AccountInfo } from "@azure/msal-browser";
import { BrowserRouter as Router, Route } from 'react-router-dom'
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  from,
  createHttpLink,
  gql
} from "@apollo/client";

import {Button, CircularProgress, TextField} from "@mui/material";
// @ts-ignore
import { WidgetLoader, Widget } from 'react-cloudinary-upload-widget';
import Header from "../components/header";

/**
 * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
 * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
 * only render their children if a user is authenticated or unauthenticated, respectively. For more, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const MainPage = () => {
  
  return (
    
            <>
              

            </>
  );
};

export default MainPage;